import { useEffect, useState } from 'react';
import { HTTP_METHOD, getDefaultOptions } from '../async/GetAsyncOptions';
import { IAppConfig } from '../interface/IAppConfig';

export type TRequestProgressStatus = 'none' | 'in-progress' | 'done-ok' | 'done-error';

export const useHousehold = (props: IAppConfig) => {
  const [state, setState] = useState<{ value: string; progress: TRequestProgressStatus; error: unknown }>({
    value: '',
    progress: 'none',
    error: undefined
  });

  useEffect(() => {
    const fetchHouseholdSize = async () => {
      setState((previousState) => ({ ...previousState, progress: 'in-progress' }));
      const options = getDefaultOptions(HTTP_METHOD.GET, props, 'wso2Secured');
      try {
        const response = await fetch(`${props.apiGatewayBase}/v2/onlinesales-services/api/customer/household`, options);

        if (response.ok) {
          const data = await response.json();
          setState((previousState) => ({
            ...previousState,
            value: '' + data.householdSize,
            progress: 'done-ok'
          }));
        } else {
          setState((previousState) => ({
            ...previousState,
            value: '',
            progress: 'done-error',
            error: 'failed getting household size'
          }));
        }
      } catch (error) {
        setState((previousState) => ({
          ...previousState,
          value: '',
          progress: 'done-error',
          error: error
        }));
      }
    };

    if (state.progress === 'none') {
      fetchHouseholdSize();
    }
  }, [props, state.progress]);

  return { state };
};
